import { gql } from '@apollo/client';
import config from '../../config';

const index = config.algolia.algolia_prefix + 'stylists_query_suggestions';
export const STYLIST_SUGGESTION = gql`
    query LocationsQuery($query: String!, $filters: String!, $facets: [String]!) {
        stylist_suggestions
            @algolia(
                __typename: "stylists_query_suggestions"
                index: ${index}
                filters: $filters
                hitsPerPage: 20
                query: $query
                facets: $facets
            ) {
            hits
            nbHits
            facets
            page
            nbPages
        }
    }
`;
